import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PropertyService } from 'src/app/_shared/service/property.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { environment } from 'src/environments/environment';
import { ReportsService } from '../reports.service';
import { ReportsState } from '../reports.state';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss'],
})
export class SearchListComponent implements OnInit {
  @ViewChild('listPaginator', { static: false }) listPaginator: MatPaginator;
  @ViewChild('propertyListContainer') propertyListContainer: ElementRef;
  @Output() propertySelected = new EventEmitter<any>();
  @Input() source: string;

  isStreetViewAvailable = true;
  streetView: any;
  propertyList: Array<any> = [];
  listingImageBaseUrl = environment.listingImageBaseUrl;
  searchPropertyInput: any;
  defaultPlace: any;
  selectedProperty: any = null;
  pageSize: any = 20;
  pageIndex: number = 0;

  onDestroyNotifier$ = new Subject();

  constructor(
    private cdr: ChangeDetectorRef,
    public reportsState: ReportsState,
    public reportsService: ReportsService,
    public propertyService: PropertyService,
    public userState: UserState
  ) {}

  ngOnInit(): void {
    this.reportsState.listPropertySet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      this.propertyList = [];
      this.propertySelected.emit(null);
      if (res && res.length > 0) {
        res.forEach((element) => {
          if (element?.CloseDate && element?.ClosePrice) {
            if (this.calculateDateDifference(element.CloseDate) < 183) {
              element['valueTarget'] = element?.ClosePrice;
            }
          }
          element.isStreetViewAvailable = true;
          element.defaultPlace = { lat: Number(element.Latitude), lng: Number(element.Longitude) };
        });
        this.propertyList = res;
      }
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    this.reportsState.searchAddress$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        let addressObj: any = {
          ...res,
          pagenumber: 1,
          pagesize: 20,
        };
        if (addressObj.SubPremise == null) {
          delete addressObj.SubPremise;
        }

        const isPartialAddress = Object.values(addressObj).some((value) => value === null);
        this.reportsState.listPropertySetCount = null;
        this.searchPropertyInput = addressObj;
        this.pageIndex = 0;
        if (isPartialAddress === true) {
          this.reportsService.searchPropertyDetails(addressObj);
        } else {
          const listingObj = {
            streetAddress: `${addressObj.StreetNumber} ${addressObj.StreetName}`,
            city: addressObj.City,
            state: addressObj.State,
            zip: addressObj.Zip,
          };

          this.propertyService.getListingDetailsByCompleteAddress({ address: listingObj }, '').subscribe(
            (res) => {
              if (res && res.PMXPropertyId) {
                this.getDetails(res);
              } else {
                // Complete address search returned no data
                this.reportsService.searchPropertyDetails(addressObj);
              }
            },
            (err) => {
              console.error('getListingDetailsByCompleteAddress failed:', err);
            }
          );
        }
      }
    });

    this.reportsState.searchPropertyInput.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.searchPropertyInput = res;
        this.pageIndex = 0;
        this.reportsService.searchPropertyDetails(res);
      }
    });
  }

  ngOnDestroy() {
    this.reportsState.searchAddressValue = null;
    this.reportsState.searchPropertyValue = null;
    this.reportsState.listPropertySetValue = null;
    this.reportsState.listPropertySetCount = null;
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  getDetails(property) {
    if (this.source === 'dashboard') {
      this.selectedProperty = property;
      this.propertySelected.emit(property);
      this.cdr.detectChanges();
      return;
    }
    this.reportsState.isLoadingCreateReport = true;
    this.reportsState.propertyDetailsCardValue = property;
    this.reportsState.showPropertyDetailsCardValue = true;
    // this.propertySelected.emit(property);
    this.cdr.detectChanges();
  }

  onPageChange(event) {
    this.searchPropertyInput.pagenumber = event.pageIndex + 1;
    this.reportsService.searchPropertyDetails(this.searchPropertyInput);
  }

  calculateDateDifference(date1: string): number {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date();
    const differenceInMs = Math.abs(parsedDate1.getTime() - parsedDate2.getTime());
    const differenceInDays = differenceInMs / (1000 * 3600 * 24);
    return differenceInDays;
  }
  onStreetViewAvailable(isAvailable: boolean) {
    this.isStreetViewAvailable = isAvailable;
  }

  setStreetView(event: any, property) {
    this.streetView = event;
    property.isStreetViewAvailable = event;
  }

  shouldShowStreetView(property): boolean {
    return property.isStreetViewAvailable !== false;
  }
}
